import { OnboardingAdapter } from '~/services/adapters/onboarding.adapter';
import type { RootStore } from '~/stores/root.store';

export class OnboardingService extends OnboardingAdapter {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        super(rootStore.apiService);
        this.rootStore = rootStore;
    }
}
